(function () {
  'use strict';

  // ── Scroll / transparent header ──────────────────────────────────────────────

  const header = document.getElementById('site-header');
  if (!header) return;

  const isTransparent = header.dataset.transparent === 'true';
  const SCROLL_THRESHOLD = 80;

  function updateHeaderState() {
    if (!isTransparent) return;
    header.classList.toggle('site-header--scrolled', window.scrollY > SCROLL_THRESHOLD);
  }

  if (isTransparent) {
    updateHeaderState();
    let ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateHeaderState();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── Hamburger → mobile sidebar ────────────────────────────────────────────────

  const hamburger = header.querySelector('.site-header__hamburger');
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('sidebar:open'));
      hamburger.setAttribute('aria-expanded', 'true');
    });
  }

  // ── Mega menu ─────────────────────────────────────────────────────────────────
  //
  //  Desktop: hover-to-open with short delay (prevents accidental opens).
  //  Click on trigger also toggles (keyboard / touch-laptop users).
  //  Escape closes any open panel.
  //  Clicking outside closes all panels.
  //  Backdrop fades in behind content when a panel is open.
  //

  const megaItems   = Array.prototype.slice.call(header.querySelectorAll('.mega-nav__item'));
  const backdrop    = document.querySelector('.mega-backdrop');

  if (!megaItems.length) return;

  var openTimer  = null;
  var closeTimer = null;
  var currentOpen = null;   // the currently open .mega-nav__item

  function openPanel(item) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);

    // Close previous if different
    if (currentOpen && currentOpen !== item) {
      _close(currentOpen);
    }

    item.classList.add('is-open');
    item.querySelector('.mega-nav__trigger').setAttribute('aria-expanded', 'true');
    var panel = item.querySelector('.mega-panel');
    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
      panel.removeAttribute('inert');
    }
    currentOpen = item;

    if (backdrop) backdrop.classList.add('is-visible');
  }

  function _close(item) {
    item.classList.remove('is-open');
    item.querySelector('.mega-nav__trigger').setAttribute('aria-expanded', 'false');
    var panel = item.querySelector('.mega-panel');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
    }
    if (currentOpen === item) currentOpen = null;
  }

  function closeAll() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    megaItems.forEach(_close);
    if (backdrop) backdrop.classList.remove('is-visible');
    currentOpen = null;
  }

  megaItems.forEach(function (item) {
    var trigger = item.querySelector('.mega-nav__trigger');
    var panel   = item.querySelector('.mega-panel');

    if (panel) {
      var panelId = panel.id || 'mega-panel-' + megaItems.indexOf(item);
      panel.id = panelId;
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
      trigger.setAttribute('aria-controls', panelId);
    }

    // Hover — open after 80ms delay (prevents accidental opens while passing)
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { openPanel(item); }, 80);
    });

    // Leave item + panel → close after 120ms (gives time to move to panel)
    item.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        _close(item);
        if (backdrop) backdrop.classList.remove('is-visible');
      }, 120);
    });

    // Click trigger also toggles (for keyboard / non-hover users)
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (item.classList.contains('is-open')) {
        closeAll();
      } else {
        openPanel(item);
      }
    });

    // Keep panel alive while mouse is over it
    if (panel) {
      panel.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
      panel.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          _close(item);
          if (backdrop) backdrop.classList.remove('is-visible');
        }, 80);
      });
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && currentOpen) {
      var returnTrigger = currentOpen.querySelector('.mega-nav__trigger');
      closeAll();
      if (returnTrigger) returnTrigger.focus();
    }
  });

  // Close on click outside header
  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) closeAll();
  });

  // Backdrop click closes
  if (backdrop) {
    backdrop.addEventListener('click', closeAll);
  }

})();

// ── Search overlay ───────────────────────────────────────────────────────────
(function () {
  'use strict';

  var i18n = window.casifyI18n || {};

  var trigger   = document.getElementById('header-search-trigger');
  var overlay   = document.getElementById('search-overlay');
  var backdrop  = document.getElementById('search-overlay-backdrop');
  var closeBtn  = document.getElementById('search-overlay-close');
  var input     = document.getElementById('search-overlay-input');
  var results   = document.getElementById('search-overlay-results');
  var overlayReturnFocus = null;

  if (!trigger || !overlay) return;

  // Capture the static hint markup (popular chips) so we can restore it
  // when the input is cleared.
  var defaultHintHTML = results ? results.innerHTML : '';

  function openOverlay() {
    overlayReturnFocus = document.activeElement;
    overlay.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('inert');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 60);
  }

  function closeOverlay() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('inert', '');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (input) input.value = '';
    if (results) results.innerHTML = defaultHintHTML;
    if (overlayReturnFocus && overlayReturnFocus.focus) overlayReturnFocus.focus();
    overlayReturnFocus = null;
  }

  trigger.addEventListener('click', openOverlay);
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  if (backdrop) backdrop.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeOverlay();
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(overlay.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ── Predictive search (Shopify's native /search/suggest.json) ──
  // Returns products matching the query in real time. Picked up automatically
  // by Search & Discovery for relevance tuning.
  var fetchTimer = null;
  var searchController = null;

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // /search/suggest.json returns price as a string in euros (e.g. "19.99"),
  // not cents — convert accordingly.
  function formatMoney(price) {
    var euros = typeof price === 'string' ? parseFloat(price) : price / 100;
    if (isNaN(euros)) return '';
    return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format(euros);
  }

  function renderSuggestions(products, collections) {
    if (!results) return;
    var hasProducts    = products && products.length > 0;
    var hasCollections = collections && collections.length > 0;

    if (!hasProducts && !hasCollections) {
      results.innerHTML = '<p class="search-overlay__no-results">' + (i18n.searchNoResults || 'Geen resultaten gevonden voor deze zoekopdracht.') + '</p>';
      return;
    }

    var html = '';

    if (hasCollections) {
      html += '<p class="search-overlay__hint-label">' + (i18n.searchCollections || 'Collections') + '</p>';
      html += '<div class="search-overlay__chips">';
      collections.forEach(function (c) {
        html += '<a href="' + escapeHTML(c.url) + '" class="search-overlay__chip">' + escapeHTML(c.title) + '</a>';
      });
      html += '</div>';
    }

    if (hasProducts) {
      if (hasCollections) html += '<div style="height: 18px;"></div>';
      html += '<p class="search-overlay__hint-label">' + (i18n.searchProducts || 'Products') + '</p>';
      html += '<div class="search-overlay__suggestions">';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? p.featured_image.url
          : (p.image || '');
        html += ''
          + '<a href="' + escapeHTML(p.url) + '" class="search-overlay__suggest-item">'
          +   '<img src="' + escapeHTML(img) + '" class="search-overlay__suggest-img" alt="' + escapeHTML(p.title) + '" loading="lazy">'
          +   '<div class="search-overlay__suggest-info">'
          +     '<p class="search-overlay__suggest-title">' + escapeHTML(p.title) + '</p>'
          +     '<p class="search-overlay__suggest-price">' + formatMoney(p.price) + '</p>'
          +   '</div>'
          + '</a>';
      });
      html += '</div>';
    }

    results.innerHTML = html;
  }

  function fetchSuggestions(q) {
    if (!q || q.length < 2) {
      if (searchController) searchController.abort();
      if (results) results.innerHTML = defaultHintHTML;
      return;
    }
    if (searchController) searchController.abort();
    searchController = new AbortController();
    var localeRoot = i18n.localeRoot || '/';
    if (localeRoot.slice(-1) !== '/') localeRoot += '/';
    var url = localeRoot + 'search/suggest.json'
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=last';
    fetch(url, { signal: searchController.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data && data.resources && data.resources.results) || {};
        renderSuggestions(res.products || [], res.collections || []);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        // Network error — fall back silently to default hints
        if (results) results.innerHTML = defaultHintHTML;
      });
  }

  if (input) {
    input.addEventListener('input', function () {
      if (fetchTimer) clearTimeout(fetchTimer);
      var q = this.value.trim();
      fetchTimer = setTimeout(function () { fetchSuggestions(q); }, 180);
    });
  }
})();
